module.exports = __webpack_public_path__ + "img/arrow.dfd14112.svg";